import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useRef, useState, Children } from 'react';
import PropTypes from 'prop-types';
import { utils } from '@gisatcz/ptr-utils';
import Timeline from '../Timeline';
import TimeLineHover from '../TimeLineHover';
import { HoverHandler, getTootlipPosition } from '@gisatcz/ptr-core';
import XAxis from '../XAxis';
import './style.scss';
import { isEqual as _isEqual, isEmpty as _isEmpty } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TOOLTIP_PADDING = 5;
var MIN_TIMELINE_HEIGHT = 4;

var MapTimeline = function MapTimeline(_ref) {
  var LayerRowComponent = _ref.LayerRowComponent,
      levels = _ref.levels,
      periodLimit = _ref.periodLimit,
      initPeriod = _ref.initPeriod,
      onHover = _ref.onHover,
      onClick = _ref.onClick,
      vertical = _ref.vertical,
      children = _ref.children,
      getHoverContent = _ref.getHoverContent,
      periodLimitOnCenter = _ref.periodLimitOnCenter,
      selectMode = _ref.selectMode,
      onLayerClick = _ref.onLayerClick,
      layers = _ref.layers,
      mapKey = _ref.mapKey,
      LegendComponent = _ref.LegendComponent,
      minTimelineHeight = _ref.minTimelineHeight,
      contentHeight = _ref.contentHeight;
  var wrapperRef = useRef();

  var _useState = useState({
    period: _objectSpread({}, initPeriod),
    dayWidth: null,
    activeLevel: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      timelineState = _useState2[0],
      setTimelineState = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      timelineWidth = _useState4[0],
      setTimelineWidth = _useState4[1];

  useEffect(function () {
    setTimelineState(_objectSpread(_objectSpread({}, timelineState), {}, {
      period: initPeriod
    }));
  }, [initPeriod]);
  minTimelineHeight = minTimelineHeight || MIN_TIMELINE_HEIGHT * utils.getRemSize();
  var top = 0;
  var overlays = layers.map(function (layerRow) {
    top = top + (layerRow.lineHeight - layerRow.elementHeight) / 2;

    var lr = /*#__PURE__*/_jsx(LayerRowComponent, {
      layers: layers,
      layerRow: layerRow,
      onLayerClick: onLayerClick,
      top: top,
      mapKey: mapKey
    }, "".concat(JSON.stringify(layerRow)));

    top = top + layerRow.elementHeight + (layerRow.lineHeight - layerRow.elementHeight) / 2;
    return lr;
  });
  var contentHeightByLayers = top;
  var childArray = [].concat(_toConsumableArray(Children.toArray(children)), _toConsumableArray(overlays));

  var getHorizontalTootlipStyle = function getHorizontalTootlipStyle() {
    var referencePoint = 'center';
    return function () {
      var windowScrollTop = window.document.documentElement.scrollTop;
      var windowScrollLeft = window.document.documentElement.scrollLeft;
      var windowHeight = window.document.documentElement.clientHeight;
      var windowWidth = window.document.documentElement.clientWidth; //map box

      var windowBBox = [windowScrollTop, windowScrollLeft + windowWidth, windowScrollTop + windowHeight, windowScrollLeft]; // return (position,origPosX,origPosY,width,height,hoveredElemen) => {

      return function (origPosX, origPosY, width, height) {
        var position = getTootlipPosition(referencePoint, ['bottom', 'top'], windowBBox, TOOLTIP_PADDING)(origPosX, origPosY, width, height, wrapperRef.current);
        return {
          top: position.top,
          left: position.left
        };
      };
    };
  };

  var onChange = function onChange(change) {
    var update = {};

    if (change.dayWidth !== timelineState.dayWidth) {
      update['dayWidth'] = change.dayWidth;
    }

    if (!_isEqual(change.centerTime, timelineState.time)) {
      update['time'] = change.centerTime;
    }

    if (change.activeLevel !== timelineState.activeLevel) {
      update['activeLevel'] = change.activeLevel;
    }

    if (!_isEmpty(update)) {
      setTimelineState(_objectSpread(_objectSpread({}, timelineState), update));
    }
  };

  var onResize = function onResize(width) {
    setTimelineWidth(width);
  };

  return /*#__PURE__*/_jsxs("div", {
    ref: wrapperRef,
    children: [timelineWidth ? /*#__PURE__*/_jsxs("div", {
      className: 'ptr-timeline-x-axe',
      children: [/*#__PURE__*/_jsx("div", {
        className: 'ptr-timeline-legend-placeholder'
      }), /*#__PURE__*/_jsx(Timeline, {
        time: timelineState.time,
        dayWidth: timelineState.dayWidth,
        periodLimit: periodLimit,
        periodLimitOnCenter: periodLimitOnCenter,
        onChange: onChange,
        vertical: vertical,
        levels: levels,
        contentHeight: 28,
        selectMode: selectMode,
        width: timelineWidth,
        children: /*#__PURE__*/_jsx(XAxis, {}, 'maptimeline-xaxis')
      })]
    }) : null, /*#__PURE__*/_jsx("div", {
      className: 'ptr-maptimeline-scrollable',
      style: _objectSpread({}, contentHeight ? {
        height: contentHeight
      } : {}),
      children: /*#__PURE__*/_jsxs("div", {
        className: 'ptr-maptimeline',
        children: [LegendComponent && !vertical ? /*#__PURE__*/_jsx(LegendComponent, {
          layers: layers
        }) : null, /*#__PURE__*/_jsx("div", {
          className: 'ptr-maptimeline-wrapper',
          children: /*#__PURE__*/_jsx(HoverHandler, {
            getStyle: getHorizontalTootlipStyle(),
            conextId: 'TimeLineContext',
            children: /*#__PURE__*/_jsx(TimeLineHover, {
              getHoverContent: getHoverContent,
              children: /*#__PURE__*/_jsx(Timeline, {
                dayWidth: timelineState.dayWidth,
                time: timelineState.time,
                periodLimit: periodLimit,
                periodLimitOnCenter: periodLimitOnCenter,
                onChange: onChange,
                onHover: onHover,
                onClick: onClick,
                vertical: vertical,
                levels: levels,
                contentHeight: Math.max(contentHeightByLayers, minTimelineHeight),
                selectMode: selectMode,
                onResize: onResize,
                children: childArray
              })
            })
          })
        })]
      })
    })]
  });
};

MapTimeline.propTypes = {
  LayerRowComponent: PropTypes.func,
  LegendComponent: PropTypes.func,
  children: PropTypes.node,
  getHoverContent: PropTypes.func,
  initPeriod: PropTypes.object,
  layers: PropTypes.array,
  levels: PropTypes.array,
  mapKey: PropTypes.string,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  onLayerClick: PropTypes.func,
  periodLimit: PropTypes.object,
  periodLimitOnCenter: PropTypes.bool,
  selectMode: PropTypes.bool,
  vertical: PropTypes.bool,
  minTimelineHeight: PropTypes.number,
  contentHeight: PropTypes.number
};
export default MapTimeline;